
export default class subscriberSelectCreateByPhoneNumber {
    constructor() {
        return {
            restrict: 'A',
            scope: {
                limit: '=',
                destroy: '=',
                loaded: '=',
                target: '@'
            },
            controller: ['$scope', '$element', '$attrs', '$timeout', '$filter', 'Subscriber', 'SweetAlert', (scope, element, attr, $timeout, $filter, Subscriber, SweetAlert) => {
                const target = scope.target || '_self';
                $timeout(() => {
                    let subscriberSelect = $(element).selectize({
                        valueField: 'id',
                        labelField: 'phone_number',
                        searchField: 'phone_number',
                        plugins: ['remove_button'],
                        maxItems: scope.limit,
                        render: {
                            item: function(item, escape) {
                                return`<div>
                                            <a style="color:inherit;" href="#/subscriber/${item.id}" target="${target}">
                                                ${escape(item.phone_number)}
                                            </a>
                                       </div>`;
                            }
                        },
                        load: (query, callback) => {
                            if (query != '') {
                                Subscriber.search(query, null, null).then((result) => {
                                    callback(result.data)
                                })
                            }
                        },
                        create: (input, callback) => {
                            Subscriber.store({phone_number: input}).then((subscriber) => {
                                $timeout(() => {
                                    subscriberSelect[0].selectize.addOption({
                                        id: subscriber.data.id,
                                        phone_number: subscriber.data.phone_number
                                    })
                                    subscriberSelect[0].selectize.addItem(subscriber.data.id)
                                    subscriberSelect[0].selectize.blur();
                                    subscriberSelect[0].selectize.unlock();
                                })
                            }, (error) => {
                                if (error.status == 409) {
                                    SweetAlert.swal(
                                        $filter('translate')('SUBSCRIBER_MODAL:CREATE:ERROR'),
                                        $filter('translate')('SUBSCRIBER_MODAL:CREATE:DUPLICATE'),
                                        "error"
                                    )
                                    callback();
                                } else {
                                    SweetAlert.swal(
                                        $filter('translate')('SUBSCRIBER_MODAL:CREATE:ERROR_INPUT'),
                                        $filter('translate')('SUBSCRIBER_MODAL:CREATE:ERROR_INPUT_BODY'),
                                        "error"
                                    )
                                    callback();
                                }
                                subscriberSelect[0].selectize.unlock();
                            });
                        }
                    });

                    // Watch for option to clear selected items
                    scope.$watch('destroy', (newVal, oldVal) => {
                        if (!newVal) {
                            return
                        }

                        $timeout(() => {
                            subscriberSelect[0].selectize.clear(true)
                        })
                    });

                    var unregisterLoadedSubscribers= scope.$watch('loaded', (newVal, oldVal) => {
                        if (newVal !== false) {
                            _.map(newVal, (subscriber) => {
                                $timeout(() => {
                                    subscriberSelect[0].selectize.addOption({id: subscriber.id, phone_number: subscriber.phone_number})
                                    subscriberSelect[0].selectize.addItem(subscriber.id)
                                })
                            });
                            unregisterLoadedSubscribers();
                        }
                    });
                })
            }]
        }
    }
}
